import gql from 'graphql-tag';

export const ExternalWhiteboardTokenQuery = gql`
	query ExternalWhiteboardTokenQuery($shareToken: String!) {
		externalCanvasToken(shareToken: $shareToken) {
			token
		}
		externalContentMediaSession(shareToken: $shareToken) {
			downloadToken {
				value
			}
			configuration {
				fileStoreUrl
			}
		}
		entitlements {
			whiteboardFeatures {
				smartConnectors {
					isEntitled
				}
				smartSections {
					isEntitled
				}
			}
		}
	}
`;

// Note: This query can replace the one above when we remove the
// feature gate `public_links_whiteboard_edit` from calling code.
// "New" in its name should just be temporary until then.
export const NewExternalWhiteboardTokenQuery = gql`
	query NewExternalWhiteboardTokenQuery($shareToken: String!) {
		externalCanvasToken(shareToken: $shareToken) {
			token
		}
		externalContentMediaSession(shareToken: $shareToken) {
			accessTokens {
				readOnlyToken {
					value
				}
				readWriteToken {
					value
				}
			}
			configuration {
				fileStoreUrl
			}
		}
		entitlements {
			whiteboardFeatures {
				smartConnectors {
					isEntitled
				}
				smartSections {
					isEntitled
				}
			}
		}
	}
`;
